import enums from "@/enums";

export default {
  computed: {
    enums() {
      return enums;
    }
  },
  data() {
    return {
      formDialog: false,
      formUpload: false,
      mode: null,
      editItem: null,
      role: null
    }
  },
  methods: {
    openCreate(role) {
      this.role=role;
      this.mode=enums.FORM_MODE.CREATE;
      this.formDialog=true;
    },
    openUpdate(item) {
      this.mode=enums.FORM_MODE.UPDATE;
      this.editItem=item;
      this.role=(item && item.role)?item.role.name: item;
      this.formDialog=true;
    },
    openUpload() {
      this.mode=enums.FORM_MODE.CREATE;
      this.formUpload=true;
    },
    close() {
      this.formDialog=false;
      this.formUpload=false;
    }
  }
}